module.exports = {
    'messageError': null,
    'responseOK': true,
    'locale': 'es_ES',
    'availableAncillariesOptionsDTO': {
        'travellers': [{
            'travellerNumber': 1,
            'travellerType': 'ADULT',
            'title': 'MR',
            'name': 'Pim',
            'middleName': '',
            'firstLastName': 'RE',
            'secondLastName': 'BREUS',
            'travellerGender': null,
            'dateOfBirth': 437353200000,
            'age': null,
            'nationalityCountryCode': 'ES',
            'countryCodeOfResidence': 'ES',
            'identification': null,
            'identificationType': 'NIF',
            'identificationExpirationDate': 1607727600000,
            'identificationIssueCountryCode': null,
            'localityCodeOfResidence': null,
            'meal': null,
            'baggageSelections': [
                {
                    'segmentIndex': 0,
                    'pieces': 0,
                    'kilos': 0,
                },
                {
                    'segmentIndex': 1,
                    'pieces': 0,
                    'kilos': 0,
                },
            ],
        },
        {
            'travellerNumber': 2,
            'travellerType': 'ADULT',
            'title': 'MR',
            'name': 'Pam',
            'middleName': '',
            'firstLastName': 'RE',
            'secondLastName': 'BREUS',
            'travellerGender': null,
            'dateOfBirth': 437353200000,
            'age': null,
            'nationalityCountryCode': 'ES',
            'countryCodeOfResidence': 'ES',
            'identification': null,
            'identificationType': 'NIF',
            'identificationExpirationDate': 1607727600000,
            'identificationIssueCountryCode': null,
            'localityCodeOfResidence': null,
            'meal': null,
            'baggageSelections': [{
                'segmentIndex': 0,
                'pieces': 0,
                'kilos': 0,
            },
            {
                'segmentIndex': 1,
                'pieces': 0,
                'kilos': 0,
            }],
        }],
        'ancillaryOptionsContainer': {
            'baggageResultsResponse': [{
                'travellerType': 'Adult',
                'baggageConditions': [{
                    'segmentIndex': 0,
                    'baggageApplicationLevel': 'SEGMENT',
                    'selectableBaggage': [{
                        'baggageDescriptor': {
                            'numPieces': 0,
                            'numKilos': 0,
                        },
                        'money': {
                            'amount': 0,
                            'currencyCode': 'EUR',
                        },
                    },
                    {
                        'baggageDescriptor': {
                            'numPieces': 1,
                            'numKilos': 23,
                        },
                        'money': {
                            'amount': 36,
                            'currencyCode': 'EUR',
                        },
                    }],
                    'includedBaggage': {
                        'numPieces': 0,
                        'numKilos': -1,
                    },
                    'baggageFee': {
                        'amount': 6,
                        'currencyCode': 'EUR',
                    },
                },
                {
                    'segmentIndex': 1,
                    'baggageApplicationLevel': 'SEGMENT',
                    'selectableBaggage': [{
                        'baggageDescriptor': {
                            'numPieces': 0,
                            'numKilos': 0,
                        },
                        'money': {
                            'amount': 0,
                            'currencyCode': 'EUR',
                        },
                    },
                    {
                        'baggageDescriptor': {
                            'numPieces': 1,
                            'numKilos': 23,
                        },
                        'money': {
                            'amount': 36,
                            'currencyCode': 'EUR',
                        },
                    }],
                    'includedBaggage': {
                        'numPieces': 0,
                        'numKilos': -1,
                    },
                    'baggageFee': {
                        'amount': 6,
                        'currencyCode': 'EUR',
                    },
                }],
            },
            {
                'travellerType': 'Child',
                'baggageConditions': [],
            },
            {
                'travellerType': 'Infant',
                'baggageConditions': [],
            }],
            'seatMapResultsResponse': [{
                'segment': 0,
                'seatMapPreferencesDescriptorItemList': [{
                    'section': 0,
                    'cabin': [{
                        'firstSeatsRow': 5,
                        'lastSeatsRow': 30,
                        'seatMapRowFrom': 0,
                        'seatMapRowTo': 27,
                        'seatMapRowsCharacteristics': {
                            'exitRows': [
                                11,
                                12,
                            ],
                            'extraLegSeats': [
                                '11A',
                                '11C',
                                '11D',
                                '11E',
                                '11F',
                            ],
                            'overWingsFromRow': 9,
                            'overWingsToRow': 18,
                            'cabinColumnDistribution': [
                                'A',
                                'C',
                                'AISLE',
                                'D',
                                'F',
                            ],
                        },
                        'seats': [{
                            'seatLocation': {
                                'column': 'D',
                                'seatRow': 5,
                                'seatMapRow': 0,
                                'floor': 0,
                            },
                            'totalPrice': {
                                'amount': 25.9,
                                'currencyCode': 'EUR',
                            },
                            'providerPrice': {
                                'amount': 22,
                                'currencyCode': 'EUR',
                            },
                            'seatType': {
                                'seatType': 'AISLE',
                            },
                            'characteristics': [{
                                'seatCharacteristic': 'CHARGEABLE_SEAT',
                            },
                            {
                                'seatCharacteristic': 'INFANT_ALLOWED',
                            }],
                        },
                        {
                            'seatLocation': {
                                'column': 'F',
                                'seatRow': 5,
                                'seatMapRow': 0,
                                'floor': 0,
                            },
                            'totalPrice': {
                                'amount': 25.9,
                                'currencyCode': 'EUR',
                            },
                            'providerPrice': {
                                'amount': 22,
                                'currencyCode': 'EUR',
                            },
                            'seatType': {
                                'seatType': 'WINDOW',
                            },
                            'characteristics': [{
                                'seatCharacteristic': 'CHARGEABLE_SEAT',
                            },
                            {
                                'seatCharacteristic': 'INFANT_ALLOWED',
                            }],
                        },
                        {
                            'seatLocation': {
                                'column': 'A',
                                'seatRow': 10,
                                'seatMapRow': 5,
                                'floor': 0,
                            },
                            'totalPrice': {
                                'amount': 18.9,
                                'currencyCode': 'EUR',
                            },
                            'providerPrice': {
                                'amount': 15,
                                'currencyCode': 'EUR',
                            },
                            'seatType': {
                                'seatType': 'WINDOW',
                            },
                            'characteristics': [{
                                'seatCharacteristic': 'CHARGEABLE_SEAT',
                            }],
                        },
                        {
                            'seatLocation': {
                                'column': 'C',
                                'seatRow': 10,
                                'seatMapRow': 5,
                                'floor': 0,
                            },
                            'totalPrice': {
                                'amount': 18.9,
                                'currencyCode': 'EUR',
                            },
                            'providerPrice': {
                                'amount': 15,
                                'currencyCode': 'EUR',
                            },
                            'seatType': {
                                'seatType': 'AISLE',
                            },
                            'characteristics': [{
                                'seatCharacteristic': 'CHARGEABLE_SEAT',
                            }],
                        },
                        {
                            'seatLocation': {
                                'column': 'A',
                                'seatRow': 11,
                                'seatMapRow': 6,
                                'floor': 0,
                            },
                            'totalPrice': {
                                'amount': 33.9,
                                'currencyCode': 'EUR',
                            },
                            'providerPrice': {
                                'amount': 30,
                                'currencyCode': 'EUR',
                            },
                            'seatType': {
                                'seatType': 'WINDOW',
                            },
                            'characteristics': [{
                                'seatCharacteristic': 'CHARGEABLE_SEAT',
                            },
                            {
                                'seatCharacteristic': 'EXIT',
                            },
                            {
                                'seatCharacteristic': 'EXTRA_LEG',
                            }],
                        },
                        {
                            'seatLocation': {
                                'column': 'C',
                                'seatRow': 11,
                                'seatMapRow': 6,
                                'floor': 0,
                            },
                            'totalPrice': {
                                'amount': 33.9,
                                'currencyCode': 'EUR',
                            },
                            'providerPrice': {
                                'amount': 30,
                                'currencyCode': 'EUR',
                            },
                            'seatType': {
                                'seatType': 'AISLE',
                            },
                            'characteristics': [{
                                'seatCharacteristic': 'CHARGEABLE_SEAT',
                            },
                            {
                                'seatCharacteristic': 'EXIT',
                            },
                            {
                                'seatCharacteristic': 'EXTRA_LEG',
                            }],
                        },
                        {
                            'seatLocation': {
                                'column': 'A',
                                'seatRow': -1,
                                'seatMapRow': 26,
                                'floor': 0,
                            },
                            'totalPrice': {
                                'amount': 3.9,
                                'currencyCode': 'EUR',
                            },
                            'providerPrice': {
                                'amount': 0,
                                'currencyCode': 'EUR',
                            },
                            'seatType': {
                                'seatType': 'NO_SEAT',
                            },
                            'characteristics': [{
                                'seatCharacteristic': 'LAVATORY',
                            }],
                        },
                        {
                            'seatLocation': {
                                'column': 'F',
                                'seatRow': -1,
                                'seatMapRow': 26,
                                'floor': 0,
                            },
                            'totalPrice': {
                                'amount': 3.9,
                                'currencyCode': 'EUR',
                            },
                            'providerPrice': {
                                'amount': 0,
                                'currencyCode': 'EUR',
                            },
                            'seatType': {
                                'seatType': 'NO_SEAT',
                            },
                            'characteristics': [{
                                'seatCharacteristic': 'LAVATORY',
                            }],
                        },
                        {
                            'seatLocation': {
                                'column': 'C',
                                'seatRow': -1,
                                'seatMapRow': 26,
                                'floor': 0,
                            },
                            'totalPrice': {
                                'amount': 3.9,
                                'currencyCode': 'EUR',
                            },
                            'providerPrice': {
                                'amount': 0,
                                'currencyCode': 'EUR',
                            },
                            'seatType': {
                                'seatType': 'NO_SEAT',
                            },
                            'characteristics': [],
                        },
                        {
                            'seatLocation': {
                                'column': 'D',
                                'seatRow': -1,
                                'seatMapRow': 26,
                                'floor': 0,
                            },
                            'totalPrice': {
                                'amount': 3.9,
                                'currencyCode': 'EUR',
                            },
                            'providerPrice': {
                                'amount': 0,
                                'currencyCode': 'EUR',
                            },
                            'seatType': {
                                'seatType': 'NO_SEAT',
                            },
                            'characteristics': [],
                        },
                        ],
                        'cabinFloor': 0,
                    }],
                }],
            }],
        },
        'collectionMethods': [{
            'fee': null,
            'collectionMethodType': 'CREDITCARD',
            'id': 16,
            'creditCardType': {
                'code': 'MP',
                'name': 'mastercard prepaid',
            },
        },
        {
            'fee': null,
            'collectionMethodType': 'CREDITCARD',
            'id': 9,
            'creditCardType': {
                'code': 'AX',
                'name': 'american express',
            },
        },
        {
            'fee': null,
            'collectionMethodType': 'CREDITCARD',
            'id': 1,
            'creditCardType': {
                'code': 'VI',
                'name': 'visa credit',
            },
        },
        {
            'fee': null,
            'collectionMethodType': 'CREDITCARD',
            'id': 18,
            'creditCardType': {
                'code': 'VE',
                'name': 'visa electron',
            },
        },
        {
            'fee': null,
            'collectionMethodType': 'SECURE3D',
            'id': 7,
            'creditCardType': {
                'code': 'MA',
                'name': 'maestro',
            },
        },
        {
            'fee': null,
            'collectionMethodType': 'CREDITCARD',
            'id': 8,
            'creditCardType': {
                'code': 'MD',
                'name': 'master card debit',
            },
        },
        {
            'fee': null,
            'collectionMethodType': 'CREDITCARD',
            'id': 2,
            'creditCardType': {
                'code': 'CA',
                'name': 'master card credit',
            },
        },
        {
            'fee': null,
            'collectionMethodType': 'CREDITCARD',
            'id': 4,
            'creditCardType': {
                'code': 'VD',
                'name': 'visa debit',
            },
        }],
        'currencyConfig': [{
            'currencyInFront': false,
            'currencySymbol': '€',
            'currencyCode': 'EUR',
            'decimalSeparator': ',',
            'thousandSeparator': '.',
            'decimalPlaces': 2,
            'pattern': '#,##0.00;-#,##0.00',
            'currencySymbolPrefix': '',
            'spaceBetweenSignAndQuantity': true,
            'signPosition': 'BEFORE',
        }],
    },
};
